export const initializeGoogleAnalytics = (id: string): void => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
};

export const sendGoogleEvent = (
  event: string,
  payload?: Record<string, any>
): void => {
  if (window.gtag) {
    window.gtag("event", `mm_${event}`, payload);
  }
};
